module.exports = __webpack_public_path__ + "img/404.db30b713.svg";